export const getDefaultValues = (duelDetails) => ({
  DuelTitle: duelDetails?.DuelTitle || '',
  DuelOrderBy: duelDetails?.DuelOrderBy || '',
  DuelImageBanner: duelDetails?.DuelImageBanner || '',
  DuelMinimumScore: Number(duelDetails?.DuelMinimumScore || 0),
  DuelIsPrivate: duelDetails?.DuelIsPrivate || '',
  DuelJoinNeedPayment: duelDetails?.DuelJoinNeedPayment || 0,
  DuelAmount: duelDetails?.DuelAmount || '',
  DuelTermsAgreement: duelDetails?.DuelTermsAgreement || '',
  DuelPopupImageFile: duelDetails?.DuelPopupImageFile || '',
  PopupURL: duelDetails?.DuelPopupPopupUrl || '',
  selectedGame: duelDetails?.GameName,
  IsActive: duelDetails?.DuelIsActive === 1 ? true : false
});
